import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VideoOverlayService {
  private _videoId$ = new BehaviorSubject<string | null>(null);

  open(videoId: string) {
    this._videoId$.next(videoId);
  }

  close() {
    this._videoId$.next(null);
  }

  get videoId$(): Observable<string | null> {
    return this._videoId$.asObservable();
  }
}
